export default __webpack_public_path__ + "static/media/arrow-up-right.23ba4839.svg";